import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_line_chart = _resolveComponent("line-chart")!
  const _component_TabContent = _resolveComponent("TabContent")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_Tab = _resolveComponent("Tab")!

  return (_openBlock(), _createBlock(_component_Tab, {
    tabs: [_ctx.i18n.t('charts.line'), _ctx.i18n.t('charts.bar')],
    initialTab: _ctx.i18n.t('charts.line')
  }, {
    default: _withCtx(({ selectedTab }) => [
      _createVNode(_component_TabContent, {
        name: _ctx.i18n.t('charts.line'),
        selectedTab: selectedTab
      }, {
        default: _withCtx(() => [
          _createVNode(_component_line_chart, { chartData: _ctx.RegulationsChartData }, null, 8, ["chartData"])
        ]),
        _: 2
      }, 1032, ["name", "selectedTab"]),
      _createVNode(_component_TabContent, {
        name: _ctx.i18n.t('charts.bar'),
        selectedTab: selectedTab
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bar_chart, { chartData: _ctx.RegulationsChartData }, null, 8, ["chartData"])
        ]),
        _: 2
      }, 1032, ["name", "selectedTab"])
    ]),
    _: 1
  }, 8, ["tabs", "initialTab"]))
}